import { PublicClientApplication } from "@azure/msal-browser";
import Cookies from "js-cookie";
import { loginRequest, msalConfig } from "../../utils/msalConfig"; // Import your config
import { loginService } from "../loginService";

// /**
//  * Function to retrieve an access token.
//  * @returns {Promise<string>} The access token.
//  */

const DEV_URL = "https://agora-recruitment.crm8.dynamics.com";
const PROD_URL = "https://talenthub.crm8.dynamics.com";

const currentOrigin = window.location.origin;
const RESOURCE_URL =
  currentOrigin === "https://talenthub.intelegain.com" ? PROD_URL : DEV_URL;

export const getToken = async (navigate, setLoading) => {
  const payload = {
    grant_type: "client_credentials",
    resource: RESOURCE_URL,
  };
  return await loginService
    .getDataverseToken(payload)
    .then((response) => {
      if (response.status === 200) {
        Cookies.set("token", response.data.access_token, { expires: 1 });
        const shared_url = sessionStorage.getItem("shared_url");
        if (shared_url) {
          navigate(shared_url, {
            replace: true,
          });
        } else {
          navigate("/", { replace: true });
        }
        return true;
      }
    })
    .catch((error) => {
      console.error("Error:", error.response?.data || error.message);
    })
    .finally(() => setLoading(false));
};

const msalInstance = new PublicClientApplication(msalConfig);

export const getAccessToken = async () => {
  await msalInstance.initialize(); // Ensure MSAL is initialized

  const accounts = msalInstance.getAllAccounts();
  if (accounts.length === 0) {
    console.error("No signed-in user found.");
    return null;
  }

  try {
    const response = await msalInstance.acquireTokenSilent({
      ...loginRequest,
      account: accounts[0],
    });

    return response.accessToken;
  } catch (error) {
    console.error("Error acquiring token:", error);
    return null;
  }
};
